import {useNavigation} from '@react-navigation/native';
import React from 'react';
import {useTheme} from 'styled-components/native';

import analytics from '@react-native-firebase/analytics';

import {FocusAwareStatusBar} from '../../../../context/statusbar';

import {
  Row,
  ProfileButton,
  ChipIconSolid,
  ActionChipGhost,
  ChipIconGhost,
  ChipLabelGhost,
  HeaderContent,
  Container,
} from './styles';

import {ChipIconBox} from '../GreenHeader/styles';
import {useAuth} from '../../../../context/auth';
import {useCarrinhos} from '../../../../context/useCarrinhos';
import {SavedContent} from '../../../shared/SavedContent';

import {SafeAreaView} from 'react-native-safe-area-context';
import {RFValue} from 'react-native-responsive-fontsize';
import { Platform } from 'react-native';

interface Props {
  showSavedContainer?: boolean;
}

export function ProfileHeader({showSavedContainer = true}: Props) {
  const navigation = useNavigation();
  const theme = useTheme();

  const {isLogged, setShowSign} = useAuth();
  const {currentCarIndex} = useCarrinhos();

  function handleHelp() {
    analytics().logEvent('header_verde_clica_icone_ajuda');
    navigation.navigate('Help');
  }
  function handleUser() {
    analytics().logEvent('header_verde_clica_perfil');
    navigation.navigate('User');
  }

  function handleNavigateToAchievements(){
    if(!isLogged){
      setShowSign(true);
    }else{
      navigation.navigate('Achievements');
    }
  }


  return (
    <Container>
      <SafeAreaView
        edges={['top']}
        style={{
          backgroundColor: theme.colors.primary,
          borderBottomLeftRadius: RFValue(28),
          borderBottomRightRadius: RFValue(28),
          zIndex: 1,
          paddingTop: Platform.OS === 'web' ? RFValue(10) : RFValue(0),
        }}>
        <FocusAwareStatusBar
          barStyle="light-content"
          backgroundColor="transparent"
        />

        <HeaderContent
          style={{
            paddingBottom: showSavedContainer ? RFValue(40) : RFValue(16),
          }}>
          <Row>
            <Row>
              <ProfileButton onPress={handleUser} activeOpacity={0.7}>
                <ChipIconSolid name="gear" />
              </ProfileButton>
            </Row>

            <Row>
              <ActionChipGhost onPress={handleHelp} activeOpacity={0.7}>
                <ChipIconBox>
                  <ChipIconGhost name="question-circle" />
                </ChipIconBox>
                <ChipLabelGhost>Ajuda</ChipLabelGhost>
              </ActionChipGhost>
            {
              Platform.OS !== 'web' &&   <ActionChipGhost
                style={{backgroundColor: theme.colors.achievements_color}}
                onPress={handleNavigateToAchievements}
                activeOpacity={0.7}>
                <ChipIconBox>
                  <ChipIconGhost
                    name="trophy"
                    style={{color: theme.colors.shape}}
                  />
                </ChipIconBox>
                <ChipLabelGhost style={{color: theme.colors.shape}}>
                  Nível {currentCarIndex + 1}
                </ChipLabelGhost>
              </ActionChipGhost>
            }
            </Row>
          </Row>
        </HeaderContent>
      </SafeAreaView>
      {showSavedContainer && <SavedContent showFooterBanner={true} />}
    </Container>
  );
}
